import { Component, Inject, OnInit } from '@angular/core';
import { ReleaseSettings } from '../models/releaseSettings.interface';
import { ReleaseService } from '../services/release.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs';
import { FileUpload } from '../../shared/models/file.upload.interface';

@Component({
  selector: 'app-release-settings-edit',
  templateUrl: './release-settings-edit.component.html',
  styleUrl: './release-settings-edit.component.scss'
})
export class ReleaseSettingsEditComponent implements OnInit {
  constructor(private releaseService: ReleaseService,
    public dialogRef: MatDialogRef<ReleaseSettingsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data) { }

  releaseSettings: ReleaseSettings;
  isRequesting: boolean;
  fileBytes?: string;
  importFile?: any;
  errors: string;

  ngOnInit() {
    let releaseSettingId = this.data.id;

    this.releaseSettings = {} as ReleaseSettings;

    if (releaseSettingId === null) {       
      this.releaseSettings.releaseSettings_ShowNotification = false
      this.releaseSettings.releaseSettings_Description = null;
      this.releaseSettings.releaseSettings_FileName = null;
      this.releaseSettings.releaseSettings_HTML_Bullets = null;
      this.releaseSettings.releaseSettings_NotificationMessage = null;
      this.releaseSettings.releaseSettings_ID = null
    }
    else {
      this.releaseService.getReleaseSetting(releaseSettingId)
        .subscribe({
          next: (data) => {
            this.releaseSettings = data;                      
          }
        })
    }
  }

  saveRelease(form: NgForm) {
    this.errors = '';
    if (form.valid) {
      this.isRequesting = true;

      if (this.importFile == undefined && this.releaseSettings.releaseSettings_ID == null) {
        alert($localize`No file provided`);
        return;
      }

      if (this.importFile != undefined) {
        if (this.importFile.type != 'application/pdf') {
          alert($localize`File must be a PDF`);
          return;
        }
      }

      if (form.valid) {
        this.isRequesting = true;
        this.saveReleaseNotesAttachment();
      }
    }
  }

  saveReleaseNotesAttachment() {
    // Set File Information
    if (this.importFile != undefined) {
      this.releaseSettings.attachment = {
        fileName: this.importFile.name,
        fileSize: this.importFile.size,
        fileType: this.importFile.type,
        lastModifiedTime: this.importFile.lastModified,
        lastModifiedDate: this.importFile.lastModifiedDate,
      } as FileUpload;

      this.releaseSettings.attachment.fileAsBase64 = this.fileBytes;
    }

    this.isRequesting = true;
    this.releaseService.saveReleaseSetting(this.releaseSettings)
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe(
        {
          next: (result) => {
            if (result) {
              this.dialogRef.close(this.data);
            }
          },
          error: (error: string) => this.onError(error)
        });
  } 

  onNoClick(): void {
    this.dialogRef.close();
  }

  onError(response: string) {
    this.isRequesting = false;

    window.alert($localize`Sorry, something went wrong.  Please contact Bidit Support.` + 'r\n' + response);
    console.log(response);
  }
}
